import React, { useEffect, useState } from 'react';
import { Button } from 'components/ui/button';
import { Icon } from 'components/blocks/menu-icon/menu-icon';
import { NotificationSideSheet } from './NotificationSideSheet';

import { useNotificationFeedStore } from 'state/store/notifications/use-notification-feed-store';
import { updateNotificationVisibility } from '../services/notification-service';
import { useConfigStore } from 'state/store/config/useConfigStore';
import { useNotificationStore } from 'state/store/common/useNotificationStore';

import { useToast } from 'hooks/use-toast';
import { useTranslation } from 'react-i18next';
import { TooltipContent, Tooltip, TooltipTrigger, TooltipProvider } from 'components/ui/tooltip';
// import { useLocation } from 'react-router-dom';

export const NotificationBell: React.FC = () => {
    // const location = useLocation();
    const { t } = useTranslation();
    const { toast } = useToast();
    const [isOpen, setIsOpen] = useState(false);
    const notification = useNotificationStore((state) => state.notification);
    const clearNotification = useNotificationStore((state) => state.clearNotification);

    const { fetchAndSetNotification, unseenCount, getUnseenNotificationIds, setUnseenCount, page } = useNotificationFeedStore();

    useEffect(() => {
        // if (isOpen) {
        // Fetch notifications first
        fetchAndSetNotification(page).then(() => {
            // After fetching, get unseen IDs and mark them as seen
            if (isOpen) {
                const unseenIds = getUnseenNotificationIds();
                // console.log('unseenIds', unseenIds);
                if (unseenIds.length > 0) {

                    updateNotificationVisibilitySeen(unseenIds);

                }
            }
        });
        // }
    }, [isOpen]);

    useEffect(() => {
        if (!notification?.message?.denormalizedPayload) return;

        const rawPayload = notification.message.denormalizedPayload;


        try {
            const payload = JSON.parse(rawPayload);
            if (payload?.Message && payload.Message.type !== 'file_upload') {
                const verb = payload.Message.Verb || payload.Message.verb;
                const title = payload.Message.title || 'Notification';
                const description = payload.Message.description
                const organizationName = payload.Message.displayName

                setUnseenCount(unseenCount + 1);
                if (payload.Message.type === 'COLLABORATION') {
                    return;
                }
                // if (payload.Message.type !== 'COLLABORATION') {
                if (verb === 'REMOVE' || verb === 'FAILED' || verb === 'CANCEL') {
                    toast({
                        title: t(title) || title,
                        description: t(description, { organizationName: `${organizationName}` }) || description,
                        variant: 'destructive',
                        duration: 3000,
                    });
                } else if (verb === 'ADD' || verb === 'ACCEPT' || verb === 'CHANGE' || verb === 'SHARE') {
                    toast({
                        title: title,
                        description: t(description, { organizationName: `${organizationName}` }) || description,
                        variant: 'success',
                        duration: 3000,
                    });
                }
                clearNotification();
                // }

                return;
            }

        } catch (err) {
            // eslint-disable-next-line no-console
            console.error('Error parsing notification payload:', err);
            // Clear notification even on error to prevent retry loops
            clearNotification();
        }
    }, [notification]);

    const handleClick = () => {
        setIsOpen(true);
    };

    const updateNotificationVisibilitySeen = async (unseenIds: string[]) => {
        const config = useConfigStore.getState().configurationSettings;
        if (!config) {
            return;
        }
        const payload = {
            projectKey: config.blocksKey,
            itemIds: unseenIds,
            seen: true,
        }
        const response = await updateNotificationVisibility(config, payload);
        if (response.isSuccess) {
            fetchAndSetNotification(page);
        }
        // console.log('response', response);
    }

    return (
        <>
            <Button
                variant="ghost"
                size="icon"

                onClick={handleClick}
                aria-label="View Notifications"

                className='relative  w-6 h-6 p-1 rounded-2xl flex items-center self-center justify-center'
            >
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <div>
                                <Icon name="Bell" className="!w-4 !h-4 text-medium-emphasis" />
                            </div>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{t('NOTIFICATIONS') || 'Notifications'}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>


                {
                    unseenCount > 0 && (
                        <div className="absolute w-[18px] h-[18px] -top-2 -right-1 flex items-center justify-center rounded-full bg-primary text-destructive-foreground text-[10px] font-semibold z-10">
                            {unseenCount > 99 ? '99+' : unseenCount > 0 ? unseenCount : 0}
                        </div>
                    )
                }


            </Button>
            <NotificationSideSheet isOpen={isOpen} onClose={() => setIsOpen(false)} />
        </>
    );
};

